import compareAsc from 'date-fns/compareAsc';

import { buildDateFromTime } from 'shared/helpers/DateHelper';
import { crmNestApi } from 'widget/helpers/axios';

export default {
  computed: {
    channelConfig() {
      return window.chatwootWebChannel;
    },
    replyTime() {
      return window.chatwootWebChannel.replyTime;
    },

    async checkOutOfOffice() {
      console.log(
        'CHECK_OUT_OF_OFFICE CRM_NEST_URL : ' + process.env.CRM_NEST_URL
      );
      // ENV["GA_TRACKING_ID"];
      console.log(
        'CHECK_OUT_OF_OFFICE process.env : ' + JSON.stringify(process.env)
      );

      console.log('CHECK_OUT_OF_OFFICE NODE_ENV : ' + process.env.NODE_ENV);

      let CRM_NEST_URL;
      if (window.location.host.includes('localhost')) {
        CRM_NEST_URL = 'http://localhost:5431/crm-nest';
      } else if (window.location.host.includes('.sandbox.foldhealth.io')) {
        CRM_NEST_URL = 'https://sandbox.foldhealth.io/crm-nest';
      } else if (window.location.host.includes('.qa.foldhealth.io')) {
        CRM_NEST_URL = 'https://qa.foldhealth.io/crm-nest';
      } else if (window.location.host.includes('.dev.foldhealth.io')) {
        CRM_NEST_URL = 'https://dev.foldhealth.io/crm-nest';
      } else if (window.location.host.includes('.foldhealth.io')) {
        CRM_NEST_URL = 'https://foldhealth.io/crm-nest';
      }

      const result = await crmNestApi.get(
        `${CRM_NEST_URL}/inbox/availablity?websiteToken=${window.chatwootWebChannel.websiteToken}`
        // `${process.env.CRM_NEST_URL}/inbox/availablity?websiteToken=yvTwbZzv2vouwCcFnCaHFpgo`
      );
      const schedules = result.data.businessHours;
      const today = new Date();
      const convertedStartDate = new Date();
      const convertedEndDate = new Date();
      const day = today.getDay();
      let isOutOfOffice = true;
      console.log('---day', day);
      for (let i = 0; i < schedules.length; i += 1) {
        const schedule = schedules[i];
        const daysOfWeek = schedule.daysOfWeek;
        if (daysOfWeek.includes('' + day)) {
          console.log('Yes it includes');
          const startTime = schedule.startTime;
          const startTimeArray = startTime.split(':');
          const hour = startTimeArray[0];
          const minute = startTimeArray[1];
          convertedStartDate.setHours(hour);
          convertedStartDate.setMinutes(minute);
          console.log('---convertedStartDate ', convertedStartDate);

          const endTime = schedule.endTime;
          const endTimeArray = endTime.split(':');
          const hours = endTimeArray[0];
          const minutes = endTimeArray[1];
          convertedEndDate.setHours(hours);
          convertedEndDate.setMinutes(minutes);
          console.log('---convertedEndDate ', convertedEndDate);

          if (today > convertedStartDate && today < convertedEndDate) {
            console.log('---isOutOfOffice? ');
            isOutOfOffice = false;
            break;
          }
        }
      }
      console.log('returning - ', isOutOfOffice);
      if (isOutOfOffice) {
        console.log('outOfOfficeMessage - ', result.data.outOfOfficeMessage);
        return result.data.outOfOfficeMessage;
      }
      return null;
    },

    async replyTimeStatus() {
      const outOfOfficeMessage = await this.checkOutOfOffice;
      console.log('replyTimeStatus- ', outOfOfficeMessage);
      if (outOfOfficeMessage) {
        return outOfOfficeMessage;
      }
      console.log('this.replyTime', this.replyTime);
      switch (this.replyTime) {
        case 'in_a_few_minutes':
          return this.$t('REPLY_TIME.IN_A_FEW_MINUTES');
        case 'in_a_few_hours':
          return this.$t('REPLY_TIME.IN_A_FEW_HOURS');
        case 'in_a_day':
          return this.$t('REPLY_TIME.IN_A_DAY');
        default:
          return this.$t('REPLY_TIME.IN_A_FEW_HOURS');
      }
    },
    outOfOfficeMessage() {
      return this.channelConfig.outOfOfficeMessage;
    },
    async isInBetweenTheWorkingHours() {
      const {
        openHour,
        openMinute,
        closeHour,
        closeMinute,
        closedAllDay,
        openAllDay,
      } = this.currentDayAvailability;
      const { utcOffset } = this.channelConfig;
      const outOfOfficeMessage = await this.checkOutOfOffice;

      if (openAllDay) return true;

      if (closedAllDay) return false;

      const startTime = buildDateFromTime(openHour, openMinute, utcOffset);
      const endTime = buildDateFromTime(closeHour, closeMinute, utcOffset);
      const isBetween =
        compareAsc(new Date(), startTime) === 1 &&
        compareAsc(endTime, new Date()) === 1;

      if (outOfOfficeMessage) return false;

      // return !isOutOfOffice;
      console.log('isBetween', isBetween);
      return false;
    },
    currentDayAvailability() {
      const dayOfTheWeek = new Date().getDay();
      const [workingHourConfig = {}] = this.channelConfig.workingHours.filter(
        workingHour => workingHour.day_of_week === dayOfTheWeek
      );
      return {
        closedAllDay: workingHourConfig.closed_all_day,
        openHour: workingHourConfig.open_hour,
        openMinute: workingHourConfig.open_minutes,
        closeHour: workingHourConfig.close_hour,
        closeMinute: workingHourConfig.close_minutes,
        openAllDay: workingHourConfig.open_all_day,
      };
    },
    isInBusinessHours() {
      const { workingHoursEnabled } = window.chatwootWebChannel;
      return workingHoursEnabled ? this.isInBetweenTheWorkingHours : true;
    },
  },
};
